// extracted by mini-css-extract-plugin
export default {"pageWrap":"index_pageWrap__waCeg","formWrap":"index_formWrap__xtV0X","lotteryItemInput":"index_lotteryItemInput__TforZ","cloneWeekCreate":"index_cloneWeekCreate__DZvTd"};